import readMore from 'utils/read-more';

export default function initReadMores() {
  return Array.from(document.querySelectorAll('[data-read-more]')).map(el =>
    readMore(el)
  );
}
